export const GET_NOTIFICATION = "suburban/strategistV2/GET_NOTIFICATION"
export const GET_NOTIFICATION_SUCCESS = "suburban/strategistV2/GET_NOTIFICATION_SUCCESS"
export const GET_NOTIFICATION_ERROR = "suburban/strategistV2/GET_NOTIFICATION_ERROR"

export const MARK_ALL_AS_READ = "suburban/strategistV2/MARK_ALL_AS_READ"
export const MARK_ALL_AS_READ_SUCCESS = "suburban/strategistV2/MARK_ALL_AS_READ_SUCCESS"
export const MARK_ALL_AS_READ_ERROR = "suburban/strategistV2/MARK_ALL_AS_READ_ERROR"

export const CLEAR_NOTES_PHASE = "suburban/strategistV2/CLEAR_HEADER_PHASE"